<script lang="ts" setup>
import { i18n } from '@/i18n';
import TableHead from '../TableHead.vue';
import { TableContentProperty } from '../../interface/tableContentHeaders';
import ArrowIcon from '../../components/ArrowIcon.vue';
import { BusinessesForSupplierForecastTableContentViewModel } from './businessesForSupplierForecastTableContentViewModel';
import { IYearMonth } from '@/coreDomainsModule/date';
// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    forecastStartYearMonth?: IYearMonth;
  }>(),
  {
    forecastStartYearMonth: undefined,
  }
);
const businessesForSupplierTableContentVM = new BusinessesForSupplierForecastTableContentViewModel();
// emits
const emits = defineEmits<{
  (e: 'onClickSort', index: number, key: TableContentProperty, isAsc: boolean): void;
  (e: 'onMousedownResizer', event: MouseEvent, headerIndex: number): void;
}>();
//変数
const t = i18n.t;
</script>

<template>
  <TableHead
    :class="[businessesForSupplierTableContentVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: businessesForSupplierTableContentVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    :index="headerIndex"
    :resizable="
      // 幅可変な列 && 固定する列に含まれていない -> 可変幅
      header.isVariableWidth && !businessesForSupplierTableContentVM.isSticky(stableColumnCount, headerIndex)
    "
    @on-mousedown-resizer="($event) => emits('onMousedownResizer', $event, headerIndex)"
  >
    <template v-if="header.sortOption.isSortable">
      <div class="table-header__sortable-content">
        <div class="table-header__text">
          {{ t(businessesForSupplierTableContentVM.getHeaderText(header.key, forecastStartYearMonth)) }}
        </div>
        <ArrowIcon :asc="header.sortOption.isAsc" @on-click="emits('onClickSort', headerIndex, header, header.sortOption.isAsc)" />
      </div>
    </template>
    <template v-else>
      <div class="table-header__text">
        {{ t(businessesForSupplierTableContentVM.getHeaderText(header.key, forecastStartYearMonth)) }}
      </div>
    </template>
  </TableHead>
</template>

<style scoped lang="scss"></style>
